module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"saving":"saving","save-failed":"There was an issue saving your data. ","save-failed-link":"Reload page.","offline":"Unable to connect to the internet."},"ja":{"saving":"保存中","save-failed":"保存が失敗しました。ページを","save-failed-link":"更新する","offline":"インタネット接続がありません。"}}')
  delete Component.options._Ctor
}
